function toggleSessionStorageAgeCheck() {
  let ageCheck = sessionStorage.getItem('ageCheck');

  if (ageCheck == 1) {
    sessionStorage.setItem('ageCheck', 0);
  } else {
    sessionStorage.setItem('ageCheck', 1);
  }

  runAgeCheck();
}

function runAgeCheck() {
  // console.log('Running runAgeCheck()');
  let ageCheck = sessionStorage.getItem('ageCheck');
  let agree = document.querySelector('#agree');
  // let checkout = document.querySelector('#CartDrawer-Checkout');
  let checkout = document.querySelector('#checkout'); 
  
  
  if (ageCheck == 1) {
    agree.checked = true;
    checkout.disabled = false; 
  } else {
    agree.checked = false;
    checkout.disabled = true;
  }
}

setInterval(runAgeCheck, 500);

// Rewrite fetch for listening to cart updates for the drawer
(function(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
        if ([
              `${window.location.origin}/cart/add`,
              `${window.location.origin}/cart/update`,
              `${window.location.origin}/cart/change`,
              `${window.location.origin}/cart/clear`,
            ].includes(res.url)) {
          res.clone().json().then(data => { console.log('Caught cart update event'); runAgeCheck(); });
        }
    });

    return response;
  }
}(window, window.fetch));